import "./instrumentation";
import "@kindtutor/design-tokens/tokens.css";
import "@kindtutor/web-ui/styles.css";
import "./styles.css";

import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { captureReactError } from "@kindtutor/web-observability";
import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { BrowserRouter } from "react-router-dom";

import { App } from "./App";

const queryClient = new QueryClient({
  defaultOptions: { queries: { staleTime: 30_000, retry: 1 } },
});

createRoot(document.getElementById("root")!, {
  onUncaughtError: captureReactError,
  onCaughtError: captureReactError,
  onRecoverableError: captureReactError,
}).render(
  <StrictMode>
    <QueryClientProvider client={queryClient}>
      <BrowserRouter>
        <App />
      </BrowserRouter>
    </QueryClientProvider>
  </StrictMode>,
);
